<template>
  <div class="ai-chart-message">
    <highcharts :options="inlineChartOptions" />
    <v-btn
      class="ai-chart-message__expand-btn"
      data-id-e2e="aiChartExpandBtn"
      icon
      size="x-small"
      variant="tonal"
      :title="'Expand chart'"
      @click="showDialog = true"
    >
      <v-icon size="16">mdi-fullscreen</v-icon>
    </v-btn>

    <!-- ai-dialog--full-viewport: opt out of the panel-offset restriction so the
         dialog scrim covers the full viewport rather than just the content area. -->
    <v-dialog
      v-model="showDialog"
      max-width="90vw"
      class="ai-dialog--full-viewport"
      data-id-e2e="aiChartDialog"
    >
      <BaseDialogCard :title="chartData?.title?.text || 'Chart'" @close="showDialog = false">
        <highcharts :options="dialogChartOptions" class="ai-chart-message__dialog-chart" />
      </BaseDialogCard>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import BaseDialogCard from '@/components/BaseDialogCard.vue';

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
});

const showDialog = ref(false);

const inlineChartOptions = computed(() => ({
  ...props.chartData,
  chart: {
    ...props.chartData?.chart,
    height: 240,
    animation: false,
    style: { fontSize: '13px', ...props.chartData?.chart?.style },
  },
  credits: { enabled: false },
}));

const dialogChartOptions = computed(() => ({
  ...props.chartData,
  chart: {
    ...props.chartData?.chart,
    height: 580,
    animation: false,
    style: { fontSize: '13px', ...props.chartData?.chart?.style },
  },
  title: { text: null },
  credits: { enabled: false },
}));
</script>

<style scoped>
.ai-chart-message {
  position: relative;
  width: 100%;
}

.ai-chart-message__expand-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
  opacity: 0.65;
  transition: opacity 0.15s;
}

.ai-chart-message:hover .ai-chart-message__expand-btn {
  opacity: 1;
}

.ai-chart-message__dialog-chart {
  width: 100%;
}
</style>
